import { HttpClient } from "./types";

/**
 * Política de privacidad de la tienda: un PDF que carga el administrador desde el admin.
 * Si la tienda no cargó ninguno, `configurada` es false y el resto de los campos vienen en null.
 */
export interface PoliticaPrivacidadDTO {
    configurada: boolean;
    url: string | null;
    nombreArchivo: string | null;
    /** Fecha y hora (UTC, ISO 8601) de la última carga. */
    fechaActualizacion: string | null;
}

export const createPoliticaPrivacidadService = (httpClient: HttpClient) => {
    return {
        get: (): Promise<PoliticaPrivacidadDTO> => {
            return httpClient.get<PoliticaPrivacidadDTO>("/tienda/politica-privacidad");
        },
    };
};
